// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, ref, child, get,onValue } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  // apiKey: "AIzaSyALE7hRzToblweN7EsARgmaSbrM-Y5BFM0",
  // authDomain: "al-kauser.firebaseapp.com",
  // projectId: "al-kauser",
  // storageBucket: "al-kauser.appspot.com",
  // messagingSenderId: "1080055801037",
  // appId: "1:1080055801037:web:d013919b3792e6970f7584",
  // measurementId: "G-52N4CSPMY7"
  apiKey: "AIzaSyBzh7f8gzN9JLIXxxM37GmEKFl40GOxl6A",
  authDomain: "al-kauser-b6277.firebaseapp.com",
  projectId: "al-kauser-b6277",
  storageBucket: "al-kauser-b6277.firebasestorage.app",
  messagingSenderId: "721742174703",
  appId: "1:721742174703:web:e1f7a9cbb5cd0e31f77e1a",
  measurementId: "G-CCCH1CTP15"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const fdb=getFirestore();


export function GetDatabaseVal(con) {
  console.log("In DB FUNCTION")
  const db = getDatabase();
  const starCountRef = ref(db, 'messages/' + con);
  onValue(starCountRef, (snapshot) => {
    const data = snapshot.val();
    console.log(data,"dtaa")
  })
}


// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBzh7f8gzN9JLIXxxM37GmEKFl40GOxl6A",
//   authDomain: "al-kauser-b6277.firebaseapp.com",
//   projectId: "al-kauser-b6277",
//   storageBucket: "al-kauser-b6277.firebasestorage.app",
//   messagingSenderId: "721742174703",
//   appId: "1:721742174703:web:e1f7a9cbb5cd0e31f77e1a",
//   measurementId: "G-CCCH1CTP15"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);